// @mui
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Box, Stack, Link, Card, CardHeader, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import Scrollbar from '../../../components/scrollbar';
import AppWidgetSummary from './AppWidgetSummary';
import { convertHM } from '../../../utils/timeCalculation';
import { isClient, isStakeholder } from '../../../utils/share';
// ----------------------------------------------------------------------

DashboardComponent.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  list: PropTypes.array.isRequired,
};

export default function DashboardComponent({ title, subheader, list, ...other }) {
  return (
    <Card {...other}>
      <CardHeader subheader={subheader} />

      <Scrollbar>
        <Stack spacing={3} sx={{ px: 3 }}>
          {list?.map((user) => (
            <DashboardItem key={user.id} user={user} />
          ))}
        </Stack>
      </Scrollbar>
    </Card>
  );
}

// ----------------------------------------------------------------------

DashboardItem.propTypes = {
  user: PropTypes.object,
};

function DashboardItem({ user }) {
  const navigate = useNavigate();
  const accountData = useSelector((state) => state?.login?.user || null);

  const trimText = (text) => (text?.length >= 50 ? text.substring(0, 25).concat('...') : text);

  const handleNavigateTimeline = () => {
    if(isStakeholder() || isClient()) return;
    const id = user?.id === accountData?.id ? '' : user?.id;
    const url = `../timeline/${id}`;
    navigate(url, { state: { name: user?.userName } });
  };
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Tooltip title="Show Timeline" placement="top" arrow>
            <Link
              color="inherit"
              variant="subtitle2"
              underline="hover"
              noWrap
              sx={{ cursor: 'pointer', textTransform: 'capitalize' }}
              onClick={handleNavigateTimeline}
            >
              <AccessTimeFilledIcon
                color={user?.startTime && !user?.stopTime ? 'success' : 'disabled'}
                sx={{ fontSize: 15 }}
                style={{ paddingTop: '5px' }}
              />
              {user?.userName}
            </Link>
          </Tooltip>
          <Tooltip title="Task Name" placement="top" arrow>
            <Link
              color="inherit"
              variant="subtitle2"
              underline="none"
              noWrap
              style={{ paddingLeft: '14px', textTransform: 'capitalize' }}
            >
              {trimText(user?.startTime && user?.stopTime ? '' : user?.taskName)}
            </Link>
          </Tooltip>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Tooltip title="Client Name" placement="top" arrow>
            <Link color="inherit" variant="subtitle2" underline="none" noWrap style={{ textTransform: 'capitalize' }}>
              {user?.startTime && user?.stopTime ? '' : user?.clientName}
            </Link>
          </Tooltip>
          <Tooltip title="Project Name" placement="top" arrow>
            <Link color="inherit" variant="subtitle2" underline="none" noWrap style={{ textTransform: 'capitalize' }}>
              {user?.startTime && user?.stopTime ? '' : user?.projectName}
            </Link>
          </Tooltip>
        </Box>
      </Box>
      <Grid container spacing={2} sx={{ mt: '0 !important' }}>
        <Grid item p={'16px'} xs={12} sm={6} md={3}>
          <AppWidgetSummary title="Today" total={convertHM(user?.today)} />
        </Grid>

        <Grid item p={'16px'} xs={12} sm={6} md={3}>
          <AppWidgetSummary title="Yesterday" total={convertHM(user?.yesterday)} color="info" />
        </Grid>

        <Grid item p={'16px'} xs={12} sm={6} md={3}>
          <AppWidgetSummary title="This Week" total={convertHM(user?.weekTime)} color="warning" />
        </Grid>

        <Grid item p={'16px'} xs={12} sm={6} md={3}>
          <AppWidgetSummary title="This Month" total={convertHM(user?.monthTime)} color="error" />
        </Grid>
      </Grid>
    </>
  );
}
